<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { actionMap } from "@/components/action/action";
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import ModeToggleButton from "@/components/menu/ModeToggleButton/ModeToggleButton.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { useBoardStore } from "@/store/board";
import { useLinkStore } from "@/store/link";
import { useSearchMenuStore } from "@/store/search/searchMenu";
import { useTimerStore } from "@/store/timer";
import { useUserStore } from "@/store/user";
import { useUsersOnBoardStore } from "@/store/usersOnBoard";

import RunningTimers from "../../internal/Timer/RunningTimers.vue";
import AlmStatus from "./internal/AlmStatus.vue";
import BoardUsers from "./internal/BoardUsers.vue";
import FacilitationMenu from "./internal/FacilitationMenu.vue";
import RiskyLinks from "./internal/RiskyLinks.vue";
import UserActions from "./internal/UserActions/UserActions.vue";

const searchMenuStore = useSearchMenuStore();
const showRiskyLinks = computed(() => useBoardStore().showRiskyLinks);
const links = computed(() => useLinkStore().hasRiskyLinks);
const activeTimers = computed(() => {
  const allTimers = [...useTimerStore().boardTimers, ...useTimerStore().artTimers];
  return allTimers.some((timer) => timer.data.state === "running");
});

const users = computed(() =>
  useUsersOnBoardStore().usersOnBoard.filter((user) => user.id !== useUserStore().technicalUser.id),
);

const actions = actionMap(toggleActions);

function toggleTimer() {
  toggleActions.showTimer("topbar-menu");
}
</script>

<template>
  <div>
    <AlmStatus />

    <template v-if="links && showRiskyLinks && !searchMenuStore.isSearchOpen">
      <RiskyLinks />
      <MenuItemDelimiter />
    </template>

    <template v-if="users.length > 0">
      <BoardUsers :users />
      <MenuItemDelimiter />
    </template>

    <IconButton v-bind="actions.showBoardConfig" />
    <MenuItemDelimiter :style="actions.showBoardConfig.style" />

    <FacilitationMenu />
    <MenuItemDelimiter />

    <template v-if="activeTimers">
      <RunningTimers @click.stop="toggleTimer" />
      <MenuItemDelimiter />
    </template>

    <span class="mode-toggle-wrapper">
      <ModeToggleButton is-top-level />
    </span>

    <MenuItemDelimiter />
    <UserActions />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables";

.mode-toggle-wrapper {
  margin: 0 variables.$top-menu-item-spacing;
}
</style>
